import * as querystring from "querystring";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import * as React from "react";
import { Button } from "@components/Button";
import type { SelectedMatchLink_MatchFragment } from "@components/SelectedMatchLink/__generated__/fragments";
import SearchQueryParams from "@hooks/useSearchQueryParams";
import { paths } from "@libs/paths";
import { IFImg } from "@libs/utils/IFImg";
import { toJpDate, toJpTime } from "@libs/utils/date";
import { shouldShowMatchTime } from "@libs/utils/match";
import styles from "../SearchInput/index.module.css";

type SelectedMatchLinkProps = {
  match: SelectedMatchLink_MatchFragment | undefined;
};

export const SelectedMatchLink: React.FC<SelectedMatchLinkProps> = ({
  match,
}) => {
  const { query } = useRouter();
  const { rawParams } = SearchQueryParams.useContainer();

  if (!match) {
    return (
      <Link href={`/matches?${querystring.stringify(rawParams)}`}>
        試合日程から探す
      </Link>
    );
  }

  const date = match.startsAt ? toJpDate(match?.startsAt).toUpperCase() : "";

  let time = match?.startsAt ? toJpTime(match?.startsAt).toUpperCase() : "";
  if (!shouldShowMatchTime(match)) {
    time = "未定";
  }

  // どちらかが欠けていた場合は、余分なスペースはトリムされる。
  const startsAt = `${date} ${time}`.trim();

  return (
    <div className={styles.match}>
      <div className={styles.detail}>
        <div className={classNames(styles.team, styles.teamLeft)}>
          <div className={styles.teamLogo}>
            <img src={IFImg(match.homeTeamIconPath)} alt="" />
          </div>
          <div className={styles.teamName}>
            {match.homeTeamDisplayShortName}
          </div>
        </div>
        <p className={styles.detailDate}>{startsAt}</p>
        <div className={classNames(styles.team, styles.teamRight)}>
          <div className={styles.teamName}>
            {match.awayTeamDisplayShortName}
          </div>
          <div className={styles.teamLogo}>
            <img src={IFImg(match.awayTeamIconPath)} alt="" />
          </div>
        </div>
      </div>
      <div className={styles.matchLink}>
        <Link
          href={{
            pathname: paths.matches({}),
            query: query,
          }}
          legacyBehavior
        >
          <Button
            className={styles.btn}
            styleType="outlined"
            colorType="primary"
          >
            変更する
          </Button>
        </Link>
      </div>
    </div>
  );
};
